import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const IconOnly = styled.div`
  font-size: 24px;
  line-height: 1.5;
  color: var(--color-on-background);
`

export const Container = styled.div`
  display: flex;

  gap: 8px;
  justify-content: center;
  align-items: center;

  height: 56px;

  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 12px;

  background-color: var(--color-background);
`

export const Title = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  line-height: 1.3;
  color: ${Colors.GS600};
`

export const User = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const UserAvatar = styled.img`
  width: 24px;
  height: 24px;
`

export const Username = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-on-background);
  font-weight: var(--font-weight-base-bold);
`
